/**
 * @file ImageBackground atom — image-backed container primitive.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/ImageBackground
 */
export { ImageBackground } from "@/components/ui/image-background";
